import DAPsController from './daps.controller';

export default {
    template: require('./daps.html'),
    controller: DAPsController
};
